import React from "react";
import {
	TextField,
	MenuItem,
	Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import {
	useField,
	useFormikContext
} from "formik";
import { capitalizeFirstLetterOfEachWord } from "../../../utils/text";
import CircularProgress from "@mui/material/CircularProgress";

const DropDown = ({
	data,
	onChange,
	id,
	value,
	name,
	label,
	isLoading,
	...otherProps
}) => {
	const [dropdownField, dropdownMeta, dropdownHelpers] = useField(id);
	const { setFieldValue } = useFormikContext();

	const handleChange = e => {
		const newValue = e.target.value;
		dropdownHelpers.setValue(newValue);
		if (onChange) {
			onChange(newValue);
		} else {
			setFieldValue(name, newValue);
		}
	};

	const dropdownProps = {
		...otherProps,
		select: true,
		value: value,
		variant: "outlined",
		fullWidth: true,
		margin: "normal",
		size: "small",
		error: Boolean(dropdownMeta.error),
		helperText: dropdownMeta.error || "",
	};

	const dropdown = {
		...dropdownField,
		...dropdownProps,
		name: name,
		id: id,
		label: label,
		onChange: handleChange
	};

	return (
		<>
			{isLoading ?
				<Typography sx={{ m: 1 }}>
					<CircularProgress size={15} sx={{ mr: 0.5 }} />Loading...
				</Typography>
				:
				<TextField {...dropdown}>
					{data.map(({ key, value, name }) => (
						<MenuItem key={key} value={value}>
							{capitalizeFirstLetterOfEachWord(name)}
						</MenuItem>
					))}
				</TextField>
			}
		</>
	);

};

DropDown.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	data: PropTypes.array,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired
};

export default DropDown;